// @generated by protoc-gen-connect-es v1.4.0
// @generated from file ibc/core/connection/v1/query.proto (package ibc.core.connection.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { QueryClientConnectionsRequest, QueryClientConnectionsResponse, QueryConnectionClientStateRequest, QueryConnectionClientStateResponse, QueryConnectionConsensusStateRequest, QueryConnectionConsensusStateResponse, QueryConnectionParamsRequest, QueryConnectionParamsResponse, QueryConnectionRequest, QueryConnectionResponse, QueryConnectionsRequest, QueryConnectionsResponse } from "@buf/cosmos_ibc.bufbuild_es/ibc/core/connection/v1/query_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * Query provides defines the gRPC querier service
 *
 * @generated from service ibc.core.connection.v1.Query
 */
export const Query = {
  typeName: "ibc.core.connection.v1.Query",
  methods: {
    /**
     * Connection queries an IBC connection end.
     *
     * @generated from rpc ibc.core.connection.v1.Query.Connection
     */
    connection: {
      name: "Connection",
      I: QueryConnectionRequest,
      O: QueryConnectionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Connections queries all the IBC connections of a chain.
     *
     * @generated from rpc ibc.core.connection.v1.Query.Connections
     */
    connections: {
      name: "Connections",
      I: QueryConnectionsRequest,
      O: QueryConnectionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * ClientConnections queries the connection paths associated with a client
     * state.
     *
     * @generated from rpc ibc.core.connection.v1.Query.ClientConnections
     */
    clientConnections: {
      name: "ClientConnections",
      I: QueryClientConnectionsRequest,
      O: QueryClientConnectionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * ConnectionClientState queries the client state associated with the
     * connection.
     *
     * @generated from rpc ibc.core.connection.v1.Query.ConnectionClientState
     */
    connectionClientState: {
      name: "ConnectionClientState",
      I: QueryConnectionClientStateRequest,
      O: QueryConnectionClientStateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * ConnectionConsensusState queries the consensus state associated with the
     * connection.
     *
     * @generated from rpc ibc.core.connection.v1.Query.ConnectionConsensusState
     */
    connectionConsensusState: {
      name: "ConnectionConsensusState",
      I: QueryConnectionConsensusStateRequest,
      O: QueryConnectionConsensusStateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * ConnectionParams queries all parameters of the ibc connection submodule.
     *
     * @generated from rpc ibc.core.connection.v1.Query.ConnectionParams
     */
    connectionParams: {
      name: "ConnectionParams",
      I: QueryConnectionParamsRequest,
      O: QueryConnectionParamsResponse,
      kind: MethodKind.Unary,
    },
  }
};

